import { json, checkStatus, CustomerAPI } from '@driftt/dapper'

export const api = {
  fetchHubspotMappings() {
    return CustomerAPI.get('/hubspot/mappings/attributes')
      .then(json)
  },

  patchHubspotMappings(mappings) {
    return CustomerAPI.patch('/hubspot/mappings/attributes',  mappings )
      .then(checkStatus)
      .then(json)
  },

  fetchHubspotFields() {
    return CustomerAPI.get('/hubspot/lead/fields')
      .then(json)
  },

  searchHubspotUsers(query) {
    return CustomerAPI.get(`/hubspot/users?query=${query}`)
      .then(checkStatus)
      .then(json)
  },

  fetchHubspotUserMappings() {
    return CustomerAPI.get('/hubspot/mappings/users')
      .then(checkStatus)
      .then(json)
  },

  patchHubspotUserMappings(data) {
    return CustomerAPI.patch('/hubspot/mappings/users', data)
      .then(checkStatus)
      .then(json)
  },

  fetchHubSpotContactByEmail({ email }){
    return CustomerAPI
      .get(`/hubspot/contact/enrichment?email=${encodeURIComponent(email)}`)
      .then(checkStatus)
      .then(json)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/hubspot/api.js